import Marquee from "react-fast-marquee";
import { ONLINE_MARQUEE } from "@/lib/content";
import { Reveal } from "@/components/landing/Reveal";

const marqueeStyles = [
  "text-surface",
  "text-em1/25",
  "text-surface",
  "text-gold/20",
  "text-surface",
  "text-em1/25",
];

export const OnlinePromise = () => (
  <section className="relative overflow-hidden bg-ink2 py-16 lg:py-24" data-testid="online-promise-section">
    <Marquee speed={40} gradient={false} className="py-4" data-testid="online-marquee">
      {ONLINE_MARQUEE.map((m, i) => (
        <span
          key={m}
          className={`mx-8 font-display text-6xl font-bold uppercase tracking-tight sm:text-8xl ${marqueeStyles[i % marqueeStyles.length]}`}
        >
          {m}
        </span>
      ))}
    </Marquee>

    <div className="mx-auto max-w-4xl px-4 sm:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] border border-em2/35 bg-surface p-8 text-center glow-emerald sm:p-14">
          <div className="pointer-events-none absolute left-1/2 top-0 h-40 w-96 -translate-x-1/2 rounded-full bg-em1/20 blur-[80px]" />
          <p className="relative z-10 text-xs font-bold uppercase tracking-[0.28em] text-gold">
            The BullsEdge Promise
          </p>
          <h2 className="relative z-10 mt-5 font-display text-5xl font-bold uppercase leading-[0.95] text-offwhite sm:text-6xl">
            We Don't Sell Tips.
            <br />
            <span className="text-em2">We Build Traders in 90 Days.</span>
          </h2>
          <p className="relative z-10 mx-auto mt-5 max-w-2xl text-base leading-relaxed text-mutedgreen">
            We're an academy run by traders with 10+ years of experience. We don't
            send signals or promise quick money. We help you build a plan, a risk
            rule and a routine you'll use for life — live, with mentors who trade
            every day. Outside class, our traders community is there to talk ideas
            through with you.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
